import React from "react";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import Alert from "@material-ui/lab/Alert";
import { Link as RouterLink } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    boxSizing: "border-box",
    width: "100%",
    maxWidth: 720,
    margin: "0 auto",
    padding: theme.spacing(2),
  },
}));

export default function ServicioError({ message }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Alert
        severity="error"
        action={
          <Button color="inherit" component={RouterLink} to="/">
            Ir al inicio
          </Button>
        }
      >
        {message || "No se pudo completar la solicitud. Inténtalo de nuevo más tarde."}
      </Alert>
    </div>
  );
}
